import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/check-index.hevc.mp4")